import { render } from "./RiattivazioniForm.vue?vue&type=template&id=47286bec&scoped=true"
import script from "./RiattivazioniForm.vue?vue&type=script&lang=js"
export * from "./RiattivazioniForm.vue?vue&type=script&lang=js"

import "./RiattivazioniForm.vue?vue&type=style&index=0&id=47286bec&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47286bec"]])

export default __exports__